import { BrowserModule } from '@angular/platform-browser';
import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { NgxMaskModule, IConfig } from 'ngx-mask';
import { NgbModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ComponentsModule } from './components/components.module';
import { InvoiceOptionsComponent } from './pages/invoice-options/invoice-options.component';
import { SimulationComponent } from './pages/simulation/simulation.component';
import { AcceptContractComponent } from './pages/accept-contract/accept-contract.component';
import { SendChargesComponent } from './pages/send-charges/send-charges.component';
import { SendDocumentsPhotoComponent } from './pages/send-documents-photo/send-documents-photo.component';
import { SuccessComponent } from './pages/success/success.component';
import { ErrorInterceptor } from './helpers/error.interceptor';
import { TokenInterceptor } from './helpers/token.interceptor';
import { ClientIdInterceptor } from './helpers/client-id.interceptor';
import { xKeyIInterceptor } from './helpers/xKeyI.interceptor';
import { xKeyIIInterceptor } from './helpers/xKeyII.interceptor';
import { ErrorComponent } from './pages/error/error.component';
import { XXSSProtectionInterceptor } from './helpers/XXSSProtection.interceptor';
import { XFrameOptionsInterceptor } from './helpers/XFrameOptions.interceptor';
import { WelcomeComponent } from './pages/welcome/welcome.component';

const maskConfig: Partial<IConfig> = {
  // validation: false,
};

@NgModule({
  declarations: [
    AppComponent,
    InvoiceOptionsComponent,
    SimulationComponent,
    AcceptContractComponent,
    SendChargesComponent,
    SendDocumentsPhotoComponent,
    SuccessComponent,
    ErrorComponent,
    WelcomeComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(maskConfig),
    HttpClientModule,
    NgbModule,
    NgbPopoverModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ClientIdInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: xKeyIInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: xKeyIIInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: XXSSProtectionInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: XFrameOptionsInterceptor,
      multi: true
    },
    // { provide: LOCALE_ID, useValue: "pt-br" },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
